import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import _ from "lodash";

import CollapseText from "../components/CollapseText";
import SummarySection from "../components/SummarySection";
import cardImage from "assets/images/challenges/card-home.jpg";
import anonymousAvatar from "assets/images/challenges/anonymous-avatar.png";
import anonymousAvatarLarge from "assets/images/challenges/anonymous-avatar-large.png";

const ChallengeSummary = () => {
  const {
    challengesReducer: { challenge_details },
    gameReducer: { currentUser },
    paramsReducer
  } = useSelector((state) => state);

  const leaderboard_params = _.get(
    paramsReducer,
    "paramsObj.mobile_website.challenges.leaderboard"
  );

  const [playersList, setPlayersList] = useState([]);
  const [topPlayers, setTopPlayers] = useState([]);

  useEffect(() => {
    !_.isEmpty(challenge_details.participants) &&
      setPlayersList(
        challenge_details.participants.sort((a, b) => b.data - a.data)
      );
  }, [challenge_details.participants]);

  useEffect(() => {
    if (!_.isEmpty(playersList)) {
      const length = playersList.length < 4 ? playersList.length : 3;
      let isUserIncluded = false;
      let outputArr = [];
      for (let i = 0; i < length; i++) {
        if (playersList[i].user_id === currentUser.userId) {
          isUserIncluded = true;
        }
        outputArr.push({ ...playersList[i], rank: i + 1 });
      }
      if (!isUserIncluded) {
        outputArr.pop();
        for (let i = 0; i < playersList.length; i++) {
          playersList[i].user_id === currentUser.userId &&
            outputArr.push({ ...playersList[i], rank: i + 1 });
        }
      }
      setTopPlayers(outputArr);
    }
  }, [playersList]);

  const daysLeft = () => {
    let eventdate = moment(challenge_details.end_date, "MM/DD/YYYY").add(
      1,
      "days"
    );
    let todaysdate = moment();
    return eventdate.diff(todaysdate, "days");
  };

  const RankCard = ({ index, count, class_name = "" }) => (
    <div
      key={index}
      className={`player-details-div ${class_name} ${
        count === 1 ? "first" : count === 2 ? "second" : ""
      }`}
    >
      <div className="picture-div">
        <img
          alt=""
          referrerPolicy="no-referrer"
          src={
            challenge_details.show_data === "Full"
              ? topPlayers[index].profile_img !== null
                ? topPlayers[index].profile_img
                : anonymousAvatarLarge
              : topPlayers[index].user_id === currentUser.userId
              ? topPlayers[index].profile_img !== null
                ? topPlayers[index].profile_img
                : anonymousAvatarLarge
              : anonymousAvatarLarge
          }
        />
        <div className="player-rank">
          <span className="rank-text">{topPlayers[index].rank}</span>
        </div>
      </div>
      <span className="player-progress">{`${topPlayers[index].data} ${challenge_details.unit}`}</span>
      <span className="player-name">
        {challenge_details.show_data === "Full"
          ? topPlayers[index].display_name
          : topPlayers[index].user_id === currentUser.userId
          ? topPlayers[index].display_name
          : "A Teammate"}
      </span>
    </div>
  );

  return (
    <div className="challenges-wrapper summary">
      <div className="challenge-summary">
        <div className="home-card">
          <img
            alt=""
            referrerPolicy="no-referrer"
            src={
              challenge_details.challenge_image !== null
                ? challenge_details.challenge_image
                : cardImage
            }
            className="card-top-image leaderboard"
          />
          <div className="card-content">
            <span className="challenge-time-left">{`${daysLeft()} ${
              daysLeft() === 1 ? "Day Left" : "Days Left"
            }`}</span>
            <h2 className="challenge-name">{challenge_details.name}</h2>
            <CollapseText
              // params={view_params}
              class_name="summary"
              description={challenge_details.description}
              challenge_id={challenge_details.challenge_id}
            />
          </div>
        </div>

        <SummarySection
          details={challenge_details}
          currentUserId={currentUser.userId}
        />

        <div className="leaderboard-section">
          <h2 className="leaderboard-heading"> 🏆 Team Leaderboard</h2>

          {!_.isEmpty(topPlayers) &&
            (topPlayers.length === 1 ? (
              <div className="top-players-wrapper">
                <RankCard index={0} count={1} />
              </div>
            ) : topPlayers.length === 2 ? (
              <div className="top-players-wrapper">
                <RankCard index={0} count={2} />
                <RankCard index={1} count={2} />
              </div>
            ) : (
              <div className="top-players-wrapper">
                <RankCard index={1} count={3} />
                <RankCard index={0} class_name="middle-div" count={3} />
                <RankCard index={2} count={3} />
              </div>
            ))}
        </div>

        <div className="players-section">
          <h2 className="players-heading">📈 Team Participation</h2>

          <div className="wrapper-entries">
            <div className="entries-header">
              <h3 className="entries-flex-1">Teammate</h3>
              <h3 className="entries-flex-2">Progress *</h3>
            </div>
            <div className="list-entries">
              {!_.isEmpty(playersList) &&
                playersList.map((item, index) => (
                  <div key={index} className="entries-header normal-row">
                    <div className="entries-flex-1 normal-row">
                      <img
                        alt=""
                        referrerPolicy="no-referrer"
                        src={
                          challenge_details.show_data === "Full"
                            ? item.profile_img !== null
                              ? item.profile_img
                              : anonymousAvatar
                            : item.user_id === currentUser.userId
                            ? item.profile_img !== null
                              ? item.profile_img
                              : anonymousAvatar
                            : anonymousAvatar
                        }
                      />
                      <h3>
                        {challenge_details.show_data === "Full"
                          ? item.display_name
                          : item.user_id === currentUser.userId
                          ? item.display_name
                          : "A Teammate"}
                      </h3>
                    </div>

                    <h3 className="entries-flex-2 normal-row">{item.data}</h3>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeSummary;
